import moment from 'moment';
import parseDms from './parseDms';

function _formatDateTime(value) {
  return value == null
    ? ''
    : moment
        .utc(value)
        .local()
        .format('DD-MM-YYYY  HH:mm');
}

function _formatTime(value) {
  return value == null
    ? ''
    : moment(value, ['H:m'])
        .local()
        .format('HH:mm');
}

function _formatDateTimeSec(value) {
  return value == null
    ? ''
    : moment
        .utc(value)
        .local()
        .format('DD-MM-YYYY  HH:mm:ss');
}

function _formatDateTimeTime(value) {
  return value == null
    ? ''
    : moment
        .utc(value)
        .local()
        .format('HH:mm');
}
export default {
  formatBoolean(value) {
    return value ? 'Ja' : 'Nee';
  },

  formatDate(value) {
    return value == null
      ? ''
      : moment
          .utc(value)
          .local()
          .format('DD-MM-YYYY');
  },

  formatTime(value) {
    return _formatTime(value);
  },

  formatDateTime(value) {
    return _formatDateTime(value);
  },

  formatTimeStamp(value) {
    return _formatDateTime(value);
  },

  formatTimeStampSec(value) {
    return _formatDateTimeSec(value);
  },
  formatTimeStampTime(value) {
    return _formatDateTimeTime(value);
  },
  formatMoney(value) {
    if (value === null) {
      return '';
    } else {
      return '€' + value;
    }
  },
  formatShortName(value) {
    if (!value) {
      return value;
    }
    const parts = value.split(' ');
    for (let i = 0; i < parts.length; i++) {
      parts[i] = parts[i][0];
    }
    return parts.join('');
  },
  formatShortName2(value) {
    if (!value) {
      return value;
    }
    const parts = value.split(' ');
    return parts[0];
    // for (let i = 1; i < parts.length; i++) {
    //   parts[i] = parts[i][0];
    // }
    // return parts.join('');
  },
  formatFirstLine(value) {
    if (!value) {
      return value;
    }
    const parts = value.split('\n');
    if (parts.length >= 1) {
      return parts[0];
    } else {
      return value;
    }
  },

  formatCoordinates(value) {
    try {
      return parseDms(value);
    } catch (error) {
      return null;
    }
  }
};
